import moment from 'moment'

const CREW_MEMBER_CLASS_CHOICES = {
    J: 'Journeyman',
    Y: 'Yard',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8',
    F: 'Foreman',
    S: 'Superintendent',
    A: 'Admin',
    C: 'Clerk',
}

export function cleanJobDayAssignments(assignments) {
    return assignments.map(assignment => {
        const jobDate = moment(assignment.jobDay.date)
        let listItem = { id: assignment.id, hours: "", overTime: "", doubleTime: "" }

        // notifications
        if(assignment.assignmentNotifications){
            let wasNotified = false
            let lastNotifiedString = ""
            assignment.assignmentNotifications.forEach(notification => {
                wasNotified = true
                lastNotifiedString = moment(notification.datetimeCreated).format("MM/DD/YYYY")
            })
            listItem['lastNotification'] = wasNotified ? lastNotifiedString : null
        }
        

        // name
        listItem['name'] = `${assignment.crewMember.firstName} ${assignment.crewMember.lastName}`

        // position
        listItem['position'] = CREW_MEMBER_CLASS_CHOICES[assignment.crewMember.classification]

        // time
        var start = moment(`${jobDate.format("YYYY-MM-DD")} ${assignment.startTime}`)
        listItem['time'] = `${start.format("hh:mm A")} - `
        
        // hours
        if(assignment.endTime) {
            var end = moment(`${jobDate.format("YYYY-MM-DD")} ${assignment.endTime}`)
            const totalHours = end.diff(start, 'hours', true)
            listItem['hours'] = totalHours.toFixed(1)
            listItem['time'] = `${listItem['time']} ${assignment.endTime ? end.format("hh:mm A") : ''}`

            // Mon-Fri
            if(jobDate.isoWeekday() < 6) {
                // 1 - Above 5 hours, factor in a 30 min lunch
                if(totalHours >= 5) {
                    listItem['hours'] = (totalHours - 0.5).toFixed(1)
                }
                // 2 - Above 8 hours, it's OT
                // overtime
                if(totalHours > 8.5) {
                    listItem['overTime'] = (totalHours - 8.5).toFixed(1)
                    listItem['hours'] = 8
                }

                // 3 - Above 12 hours, it DT
                if(totalHours > 12) {
                    listItem['doubleTime'] = (totalHours - 12.5).toFixed(1)
                    listItem['overTime'] = 4
                }
            } 

            // Sat
            else if(jobDate.isoWeekday() == 6) {
                // 1 - Regular hours are OT
                listItem['overTime'] = listItem['hours']
                listItem['hours'] = 0

                // 2 - Above 5 hours, factor in a 30 min lunch
                if(totalHours >= 5) {
                    listItem['overTime'] = (totalHours - 0.5).toFixed(1)
                }

                // 3 - Above 3 hours, it's DT
                if(totalHours > 8.5) {
                    listItem['doubleTime'] = (totalHours - 8.5).toFixed(1)
                    listItem['overTime'] = 8
                }
            }

            // Sun
            else if(jobDate.isoWeekday() == 7) {

                // 1 - Regular hours are DT
                listItem['doubleTime'] = listItem['hours']
                listItem['overTime'] = 0
                listItem['hours'] = 0

                // 2 - Above 5 hours, factor in 30 min lunch
                if(totalHours >= 5) {
                    listItem['doubleTime'] = (totalHours - 0.5).toFixed(1)
                }

            }
        }

        if('signOff' in assignment) {
            listItem['signOff'] = {...assignment.signOff}
        }

        return listItem
    })
}

